import AppliedSymbolBlackSvg from 'assets/images/applied/Applied_Intuition_Symbol_Black.svg';

export function useAppliedLogoSrc(): string {
  return AppliedSymbolBlackSvg;
}
